/* ==========================================================================
   Kleos — Quick-add de la tarjeta de producto (snippets/iurop-product-card)
   --------------------------------------------------------------------------
   Añade la variante al carrito por AJAX (/cart/add.js) y abre el side-cart
   (#CartDrawer). Se carga UNA sola vez (guard) y usa delegación de eventos,
   así que sirve para todas las tarjetas de la página (también las del menú:
   snippets/iurop-menu-product usa el mismo atributo data-iurop-quick-add).

   CONTRATO con el side-cart (assets/iurop-cart.js):
     1) Si existe window.iuropCart.addItem(id, qty) se usa directamente
        (él mismo refresca y abre el drawer).
     2) Si no, se hace fetch a /cart/add.js y se despacha sobre `document`:
          • 'cart:added'    → el drawer refresca y se abre
          • 'cart:updated'  detail: { cart, source } → otros listeners
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropProductCardInit) return;
  window.__iuropProductCardInit = true;

  var SELECTOR = '[data-iurop-quick-add]';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setLoading(btn, loading) {
    btn.classList.toggle('is-loading', loading);
    if (loading) {
      btn.setAttribute('aria-busy', 'true');
      if ('disabled' in btn) btn.disabled = true;
    } else {
      btn.removeAttribute('aria-busy');
      if ('disabled' in btn) btn.disabled = false;
    }
  }

  function flashState(btn, cls) {
    btn.classList.add(cls);
    window.setTimeout(function () {
      btn.classList.remove(cls);
    }, 1400);
  }

  function addViaFetch(variantId) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function () {
        return fetch(root() + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: cart, source: 'iurop-product-card' } })
        );
        // El drawer (iurop-cart.js) escucha 'cart:added': refresca y se abre.
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: cart } }));
        return cart;
      });
  }

  function quickAdd(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled || btn.classList.contains('is-loading')) return;

    setLoading(btn, true);

    var promise;
    if (window.iuropCart && typeof window.iuropCart.addItem === 'function') {
      // El propio drawer añade, refresca y se abre.
      promise = Promise.resolve(window.iuropCart.addItem(Number(variantId), 1));
    } else {
      promise = addViaFetch(variantId);
    }

    promise
      .then(function () {
        flashState(btn, 'is-added');
      })
      .catch(function (err) {
        // eslint-disable-next-line no-console
        console.warn('[iurop-product-card] No se pudo añadir al carrito:', err);
        flashState(btn, 'is-error');
      })
      .finally(function () {
        setLoading(btn, false);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!btn) return;
    event.preventDefault();
    quickAdd(btn);
  });
})();
